<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="xl"
		:title="
			modelId > 0
				? 'Edición servicio adicional'
				: 'Nuevo servicio adicional'
		"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-tabs
			no-fade
			pills
			card
			small
			vertical
			nav-class="nav-style"
			align="center"
		>
			<b-tab title="General" active>
				<b-form @submit="onSubmit">
					<b-form-row>
						<b-form-group
							:disabled="unableEdit"
							class="col-md-4 col-12"
							label="Tipo"
						>
							<b-form-select
								size="sm"
								v-model="modelInfo.type"
								:options="additionalTypesOptions"
							></b-form-select>
						</b-form-group>
						<b-form-group
							:disabled="unableEdit"
							class="col-md-4 col-12"
							label="Icono"
						>
							<b-form-select
								size="sm"
								v-model="modelInfo.code"
								:options="icons"
							></b-form-select>
						</b-form-group>
						<b-form-group
							:disabled="unableEdit"
							class="col-md-4 col-12"
							label="Nombre"
						>
							<b-form-input
								type="text"
								size="sm"
								v-model="modelInfo.name"
								required
							/>
						</b-form-group>
						<b-form-group
							:disabled="unableEdit"
							class="col-md-3 col-12"
							label="Aeropuerto (Iata)"
						>
							<b-form-input
								size="sm"
								v-model="modelInfo.restrictedByIata"
							/>
							<div class="text-danger message">Si se deja vacio, estará disponible para todos los aeropuertos</div>
						</b-form-group>

						<b-form-group
							:disabled="unableEdit"
							class="col-md-3 col-6"
							label="Complemento para"
						>
							<b-form-select
								size="sm"
								v-model="modelInfo.relatedTo"
								:options="levelOpts"
							></b-form-select>
						</b-form-group>
						<b-form-group
							:disabled="unableEdit"
							class="col-md-4 col-6"
							label="Restricción tipo de ride"
						>
							<multiselect
								:disabled="isTripTypeDisabled"
								size="sm"
								v-model="modelInfo.tripType"
								:options="tripTypeOpts"
								multiple
								placeholder="Todos"
								taggable
							/>
						</b-form-group>
						<b-form-group
							:disabled="unableEdit"
							class="col-md-2 col-12"
							label="Cutoff"
						>
							<b-input-group :append="'Horas'" size="sm">
								<b-form-input
									v-model="modelInfo.cutoff"
								></b-form-input>
							</b-input-group>
						</b-form-group>
					</b-form-row>

					<b-form-row>
						<b-form-group
							class="col-md-6 col-12"
							label="Descripcion general"
						>
							<b-textarea
								size="sm"
								v-model="modelInfo.description"
							/>
						</b-form-group>
						<b-form-group class="col-md-4 col-12" label="Estado">
							<b-form-select
								size="sm"
								v-model="modelInfo.status"
								:options="statusOptions"
							></b-form-select>
						</b-form-group>
					</b-form-row>
					<hr />

					<h3>Tarifa:</h3>
					<b-form-row>
						<b-form-group
							:disabled="unableEdit"
							class="col-md-3 col-12"
							label="Tipo tarifa"
						>
							<b-form-select
								v-model="modelInfo.rateType"
								:options="rateTypesOptions"
							></b-form-select>
						</b-form-group>

						<div
							class="col-md-9 col-12"
							v-if="modelInfo.rateType === 'person'"
						>
							<b-row>
								<b-form-group
									class="col-sm-4 col-12"
									v-for="(_rate,
									_index) in optsRateTypePerson"
									:key="_index"
									:label="'$ Precio ' + _rate.label"
								>
									<b-input-group
										:append="modelInfo.rateCurrency"
									>
										<b-form-input
											:disabled="unableEdit"
											v-model="
												modelInfo[
													_rate.id + 'Price'
												]
											"
										></b-form-input>
									</b-input-group>
								</b-form-group>
							</b-row>
						</div>

						<b-form-group class="col-3" label="$ Precio" v-else>
							<b-input-group :append="modelInfo.rateCurrency">
								<b-form-input
									:disabled="unableEdit"
									v-model="modelInfo.ratePrice"
								></b-form-input>
							</b-input-group>
						</b-form-group>
					</b-form-row>
					<div class="text-right">
						<b-button
							:disabled="unableEdit"
							variant="primary"
							type="submit"
							>{{
								modelId > 0 ? "Actualizar" : "Guardar"
							}}</b-button
						>
					</div>
				</b-form>
			</b-tab>
			<b-tab
				v-if="
					modelId > 0 &&
						$hasPermission('additionalService.translation.show')
				"
				title="Traducciones"
			>
				<TranslatableFields
					:model-id="modelId"
					:unableEdit="
						!$hasPermission('additionalService.translation.edit')
					"
					model-reference="additional-service-types"
					:translatable-fields="translatableFields"
				/>
			</b-tab>
			<b-tab
				v-if="
					modelId > 0 &&
						$hasPermission('additionalService.media.show')
				"
				title="Imagen"
			>
				<FilesRelated
					:model-id="modelId"
					:unableEdit="
						!$hasPermission('additionalService.media.update')
					"
					:unableDelete="
						!$hasPermission('additionalService.media.update')
					"
					model-reference="additional-service-types"
					:file-keys="[
						{
							label: 'Cover',
							keyName: 'coverImage',
							aspectRatio: 16 / 9,
							cropper: true
						},
						{
							label: 'Gallery',
							keyName: 'gallery[]',
							aspectRatio: 16 / 9,
							cropper: true
						}
					]"
				/>
			</b-tab>
			<b-tab
					v-if="modelId > 0"
					title="Configuracion"
				>
					<b-row>
						<b-col>
							<table class="table table-striped">
								<tr>
									<th></th>
									<th>Opción</th>
									<th>Descripción</th>
								</tr>
								<tr>
									<td>
										<b-form-checkbox
											size="lg"
											v-model="settings.internalService"
										></b-form-checkbox>
									</td>
									<td>Internal service</td>
									<td>
										Establecer este servicio adicional solo para uso interno a través del cotizador de ADMIN
									</td>
								</tr>
								<tr>
									<td>
										<b-form-checkbox
											size="lg"
											v-model="settings.editPrice"
										></b-form-checkbox>
									</td>
									<td>Editar precio</td>
									<td>
										Establecer un precio especial desde el cotizador
									</td>
								</tr>
								<tr>
									<td>
										<b-form-input
											type="text"
											size="sm"
											v-model="settings.externalSaleUrl"
											required
										/>
									</td>
									<td>Url para venta externa</td>
									<td>
										Al ingresar una URL aquí, el cliente sera redireccionado a dicha URL para continuar la compra de este servicio.
									</td>
								</tr>
							</table>
						</b-col>
					</b-row>
					<div class="text-right">
						<b-button
							:disabled="!$hasPermission('additionalService.settings.save')"
							@click="updateSettings('configAdditionalService')"
							variant="primary"
							>Actualizar</b-button
						>
					</div>
			</b-tab>
		</b-tabs>
	</b-modal>
</template>

<script>
import TranslatableFields from "@/components/helpers/TranslatableFields";
import FilesRelated from "@/components/helpers/FilesRelated";
import Multiselect from "vue-multiselect";

export default {
	props: {
		unableEdit: Boolean,
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	components: {
		TranslatableFields,
		FilesRelated,
		Multiselect
	},
	data() {
		const defaultModelInfo = {
			id: -1,
			type: "activity",
			code: "",
			name: "",
			status: "active",
			description: "",
			restrictedByIata: null,
			cutoff: 0,
			rateType: "person",
			rateCurrency: "USD",
			ratePrice: 0,
			adultPrice: 0,
			childPrice: 0,
			infantPrice: 0,
			relatedTo: "reservation"
		};
		const defaultSettings = {
			internalService: false,
			editPrice: false,
			externalSaleUrl: '',
		}
		return {
			modelId: -1,
			loading: true,
			modelInfo: { ...defaultModelInfo },
			settings: {...defaultSettings},
			defaultSettings: {...defaultSettings},
			defaultModelInfo: { ...defaultModelInfo },
			statusOptions: [
				{ value: "active", text: "Activo" },
				{ value: "inactive", text: "Inactivo" }
			],
			additionalTypesOptions: [
				{ value: "activity", text: "Actividad (Tour)" },
				{ value: "other", text: "Servicio Adicional" }
			],
			translatableFields: [
				{ label: "Nombre", field: "name", type: "inputText" },
				{
					label: "Descripción gral.",
					field: "description",
					type: "texteditor",
					col: "12"
				}
			],
			levelOpts: [
				{ value: "Reservations", text: "Reservation" },
				{ value: "TransportServices", text: "Transport Service" }
			],
			tripTypeOpts: ["A2H", "H2A", "P2P"],
			rateTypesOptions: [],
			icons: [],
			optsRateTypePerson: [
				{ id: "adult", label: "adulto" },
				{ id: "child", label: "Menor" },
				{ id: "infant", label: "Infante" }
			]
		};
	},
	computed: {
		isTripTypeDisabled() {
			return this.modelInfo.relatedTo === "Reservations";
		}
	},
	methods: {
		updateSettings(groupName) {
			let settings = {}
			if (groupName == "configAdditionalService") {
				settings = {
					internalService: this.settings.internalService,
					editPrice: this.settings.editPrice,
					externalSaleUrl: this.settings.externalSaleUrl,
				}
			}
			this.loading = true;
			this.$root.api
				.put(`/additional-services/${this.modelInfo.id}/setting-vars`, {
					settings
				})
				.then(() => {
					this.$root.showAlert("Configuraciones actualizadas");
					this.loading = false;
				})
				.catch(this.$root.handleRequestError);
		},
		onSubmit(event) {
			event.preventDefault();
			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}
			this.loading = true;
			let rParams = {
				url:
					this.modelId > 0
						? `/additional-services/${this.modelId}`
						: "/additional-services",
				method: this.modelId > 0 ? "put" : "post"
			};
			if (rParams.method == "get") {
				rParams["params"] = this.modelInfo;
			} else {
				rParams["data"] = this.modelInfo;
			}
			this.$root.api
				.request(rParams)
				.then(res => {
					this.$root.showAlert("OK!");
					this.$emit(
						"bv::refresh::table",
						"additional-services-index-list"
					);
					if (res.data.id) this.loadModel(res.data.id);
					this.successCallback(res);
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.loading = false;
				});
		},
		loadModel(id) {
			this.modelId = id;
			this.$refs["modal-view"].show();
			this.fetchModel();
		},
		fetchModel() {
			this.expediaId = null;
			this.expediaIds = [];
			if (this.modelId > 0) {
				this.loading = true;
				this.$root.api
					.get(`/additional-services/${this.modelId}`)
					.then(res => {
						this.$emit(
							"update:unableEdit",
							!this.$hasPermission("additionalService.edit")
						);
						this.modelInfo = { ...res.data };
						this.settings = {...res.data.settingVars}
						this.loading = false;
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.modelInfo = { ...this.defaultModelInfo };
				this.loading = false;
			}
		},
		getRateTypes() {
			this.$root.api
				.get(`/additional-services/options/rate-types`)
				.then(res => {
					this.rateTypesOptions = res.data;
				});
		},
		getIcons() {
			this.$root.api
				.get(`/additional-services/options/icons`)
				.then(res => {
					this.icons = res.data;
				});
		}
	},
	mounted() {
		this.getRateTypes();
		this.getIcons();
	}
};
</script>
<style scoped>
.message {
	font-weight: bold;
	line-height: 1.4;
	font-size: 12px;
}
</style>
